<div class="row" *ngIf="profileData">
    <div class="col-12">

        <div class="card">

            <div class="card-header">
                <div class="title">{{ 'EMPLOEE.EMPLOEE_PROFILE' | translate }}</div>
                <div class="tools">
                    <div class="row">
                        <div class="col-12 avatar_pic">
                            <div class="no-image" [ngClass]="{'profile-img': profileData.avatar_pic}">
                                <div *ngIf="!profileData.avatar_pic">{{noLogoLetter}}</div>
                                <img *ngIf="profileData.avatar_pic"  src="{{ profileData.avatar_pic }}"  alt="logo">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-body">
                <div class="row">
                    <div class="col-5">
                        <div class="notification-info-title">{{ 'EMPLOEE.FULL_NAME' | translate }}: </div>
                    </div>
                    <div class="col-7">
                        <div class="org-info-value">{{profileData.fullname}}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5">
                        <div class="notification-info-title">Email: </div>
                    </div>
                    <div class="col-7">
                        <div class="org-info-value">{{profileData.email}}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5">
                        <div class="notification-info-title">{{ 'ROLE' | translate }}: </div>
                    </div>
                    <div class="col-7">
                        <div class="org-info-value">{{profileData.role[0].name}}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5">
                        <div class="notification-info-title">{{ 'EMPLOEE.DEPARTMENT' | translate }}: </div>
                    </div>
                    <div class="col-7">
                        <div class="org-info-value">{{profileData.department.name}}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5">
                        <div class="notification-info-title">{{ 'EMPLOEE.POSITION' | translate }}: </div>
                    </div>
                    <div class="col-7">
                        <div class="org-info-value">{{profileData.position.name}}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5">
                        <div class="notification-info-title">{{ 'EMPLOEE.SUPERVISOR' | translate }}: </div>
                    </div>
                    <div class="col-7">
                        <div class="org-info-value">{{profileData.supervisor}}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5">
                        <div class="notification-info-title">{{ 'EMPLOEE.DATE_THE_INVITATION_WAS_SENT' | translate }}: </div>
                    </div>
                    <div class="col-7">
                        <div class="org-info-value">{{profileData.invitation_sent_date}}</div>
                    </div>
                </div>
                <div class="row notification-info">
                    <div class="col-5">
                        <div class="notification-info-title">{{ 'EMPLOEE.INVITATION_ACTIVATION_DATE' | translate }}: </div>
                    </div>
                    <div class="col-7">
                        <div class="org-info-value">{{profileData.invitation_accept_date}}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 d-flex btn-pos">
                        <button type="button" class="btn btn-light btn-sm" (click)="activeModal.dismiss(false)">
                            {{ 'CLOSE' | translate}}
                        </button>
                </div>
            </div>
        </div>

    </div>
</div>

<div class="loading" *ngIf="!profileData">
    <div *ngIf="loading"> {{ 'LOADING' | translate }}</div>
    <div *ngIf="!loading">{{ 'DATA_NOT_FOUND' | translate }}</div>
</div>